
import { useState } from "react";

import carouselpic1 from "../../assets/home/carousel-pic1.jpg";
import carouselpic2 from "../../assets/home/carousel-pic2.jpg";
import carouselpic3 from "../../assets/home/carousel-pic3.jpg";
import carouselpic4 from "../../assets/home/carousel-pic4.jpg";

import "../Carousel.css";

function MainCarousel() {
  // Carrusel original desktop
  const [step, setStep] = useState(0);

  const next = () => setStep((prev) => Math.min(prev + 1, 2));
  const prev = () => setStep((prev) => Math.max(prev - 1, 0));

  // Carrusel móvil
  const [mobileStep, setMobileStep] = useState(0);

  const images = [
    carouselpic1,
    carouselpic2,
    carouselpic3,
    carouselpic4,
  ];

  return (
    <section className="slider-container">

      {/* DESKTOP: carrusel original */}
      <div className="desktop-carousel">
        <div className="carousel-window">
          <div className={`carousel-track stage-${step}`}>
            <img src={carouselpic1} className="pic" alt="" />
            <img src={carouselpic2} className="pic" alt="" />
            <img src={carouselpic3} className="pic" alt="" />
            <img src={carouselpic4} className="pic" alt="" />
          </div>
        </div>

        <button
          className="carousel-prev"
          onClick={prev}
          disabled={step === 0}
        >
          ‹
        </button>

        <button
          className="carousel-next"
          onClick={next}
          disabled={step === 2}
        >
          ›
        </button>
      </div>

      {/* MOBILE: carrusel sencillo */}
      <div className="mobile-carousel">

        <div className="mobile-carousel-window">
          <img
            src={images[mobileStep]}
            alt={`Imagen ${mobileStep + 1}`}
            className="mobile-carousel-image"
          />
        </div>

        <div className="mobile-carousel-controls">
          <button
            onClick={() =>
              setMobileStep((prev) => Math.max(prev - 1, 0))
            }
            disabled={mobileStep === 0}
          >
            ‹
          </button>

          <button
            onClick={() =>
              setMobileStep((prev) =>
                Math.min(prev + 1, images.length - 1)
              )
            }
            disabled={mobileStep === images.length - 1}
          >
            ›
          </button>
        </div>

      </div>

    </section>
  );
}

export default MainCarousel;
